import React from "react";
import { ArrowLeft, ShieldX } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import { myLocalStorage } from "../StorageHelper";
import { getTenantCloudHomePath } from "../../utils/cloudRoleHelpers";

const TENANT_USER = "TENANT_USER";

const CloudAdminRoute = ({ element, cloudProvider }) => {
  const navigate = useNavigate();
  const role = myLocalStorage.getItem("role");

  if (role !== TENANT_USER) {
    return element;
  }

  const handleBack = () => {
    if (window.history.state?.idx > 0) {
      navigate(-1);
      return;
    }

    const fallbackPath = cloudProvider
      ? getTenantCloudHomePath(cloudProvider)
      : "/account";
    navigate(fallbackPath, { replace: true });
  };

  return (
    <div className="flex min-h-[calc(100vh-7rem)] items-center justify-center p-6">
      <Card className="w-full max-w-lg border-border/70 shadow-sm">
        <CardContent className="flex flex-col items-center px-8 py-12 text-center">
          <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
            <ShieldX className="h-7 w-7 text-primary" />
          </div>
          <h1 className="text-xl font-semibold text-foreground">
            Admin credentials required
          </h1>
          <p className="mt-2 max-w-sm text-sm leading-6 text-muted-foreground">
            This cloud page is available only to tenant administrators and system administrators.
          </p>
          <Button className="mt-6 gap-2" onClick={handleBack}>
            <ArrowLeft className="h-4 w-4" />
            Back
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default CloudAdminRoute;
